import React from 'react';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { Button } from 'reactstrap';

function PublicError({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <Card className="my-10 max-w-[1200px] mx-auto">
      <CardHeader className="flex items-center justify-center">
        <CardTitle className="text-3xl capitalize">{title}</CardTitle>
        <CardDescription className="text-xl">{description}</CardDescription>
      </CardHeader>
    </Card>
  );
}

export default PublicError;
